import { combineCls, fontSize, textColor, twCls } from 'style';

export interface ValidationErrorsProps {
  className?: string;
  errors?: string[];
}

export const ValidationErrors = ({ className, errors }: ValidationErrorsProps): JSX.Element => (
  <div className={combineCls(twCls(textColor('text-red-100'), fontSize('text-xs')), className)}>
    {errors && errors.map((err, i) => <p key={i}>{err}</p>)}
  </div>
);
